/*
  Colour swatch behaviour. Paired with snippets/uf-colour-swatches.liquid.

  Collection card: hovering (or focusing) a swatch shows that colour's photo in the card, and the
  original comes back when the pointer leaves the row. On touch there is no hover, so a tap just
  follows the link to the product page with that colour selected, which is the better outcome.

  Product page: clicking a swatch moves the gallery to that colour and scrolls to its group in the
  quick order list below.

  All wiring is delegated from document, because the collection grid re-renders on filtering and
  paginating and the quick-add modal injects its own markup after load; per-element listeners
  bound at DOMContentLoaded would be lost in both cases.
*/
(function () {
  'use strict';

  var CARD_WIDTH = 533;

  /*
    Swatch URLs are emitted by image_url at a fixed width, so the card-sized version of the same
    photo is the same URL with a different `width=`. That keeps the swatch markup free of extra
    data attributes: on a 48-card page a full srcset per swatch would be tens of kilobytes.
  */
  function atWidth(url, width) {
    return url.replace(/([?&]width=)\d+/, '$1' + width);
  }

  function cardImageFor(swatch) {
    var card = swatch.closest('.card-wrapper');
    return card ? card.querySelector('.card__media img') : null;
  }

  function showColour(swatch) {
    var img = cardImageFor(swatch);
    var thumb = swatch.querySelector('.uf-swatch__img');
    if (!img || !thumb || !thumb.getAttribute('src')) return;

    if (img.dataset.ufOriginalSrc === undefined) {
      img.dataset.ufOriginalSrc = img.getAttribute('src') || '';
      img.dataset.ufOriginalSrcset = img.getAttribute('srcset') || '';
    }

    /* srcset wins over src, so it has to go before the swap can show anything. */
    img.removeAttribute('srcset');
    img.setAttribute('src', atWidth(thumb.getAttribute('src'), CARD_WIDTH));
  }

  function restoreColour(row) {
    var swatch = row.querySelector('.uf-swatch');
    var img = swatch && cardImageFor(swatch);
    if (!img || img.dataset.ufOriginalSrc === undefined) return;

    img.setAttribute('src', img.dataset.ufOriginalSrc);
    if (img.dataset.ufOriginalSrcset) {
      img.setAttribute('srcset', img.dataset.ufOriginalSrcset);
    }
  }

  function onCardSwatch(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var swatch = target.closest('[data-uf-swatches="plp"] .uf-swatch');
    if (!swatch) return;

    var row = swatch.parentElement;
    if (row && !row.dataset.ufLeaveBound) {
      row.dataset.ufLeaveBound = '1';
      row.addEventListener('pointerleave', function () {
        restoreColour(row);
      });
    }

    showColour(swatch);
  }

  document.addEventListener('pointerover', onCardSwatch, { passive: true });
  document.addEventListener('focusin', onCardSwatch);

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var swatch = target.closest('[data-uf-swatches="pdp"] .uf-swatch');
    if (!swatch) return;

    event.preventDefault();

    var strip = swatch.closest('[data-uf-swatches="pdp"]');
    if (strip) {
      strip.querySelectorAll('.uf-swatch').forEach(function (other) {
        other.classList.remove('uf-swatch--selected');
      });
      swatch.classList.add('uf-swatch--selected');

      var current = strip.querySelector('[data-uf-swatch-current]');
      if (current && swatch.dataset.ufColour) {
        current.textContent = swatch.dataset.ufColour;
      }
    }

    /*
      The gallery keys slides as "<sectionId>-<mediaId>". Rather than thread the section id
      through Liquid, the full key is read back off the matching slide.
    */
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    /*
      Show every photo of the picked colour and hide the rest. A colour can carry more than one
      shot — Shopify allows only one image per variant, so the second angle is not variant-attached
      and is matched by the colour key Liquid stamped on each slide instead.
    */
    var key = swatch.dataset.ufKey;
    var slides = gallery.querySelectorAll('[data-uf-colour]');
    if (key && slides.length) {
      slides.forEach(function (slide) {
        slide.classList.toggle('uf-colour-hidden', slide.dataset.ufColour !== key);
      });
    }

    /*
      Point the gallery's own state at the first photo of that colour, so the lightbox and the
      zoom open on what the buyer is actually looking at. Falls back to the swatch's variant image
      for a gallery that never got colour keys.
    */
    var target = null;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].dataset.ufColour === key) { target = slides[i]; break; }
    }
    if (!target && swatch.dataset.ufMedia) {
      target = gallery.querySelector('[data-media-id$="-' + swatch.dataset.ufMedia + '"]');
    }
    if (target && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(target.dataset.mediaId, false);
    }

    /*
      Deliberately does NOT scroll. Picking a colour means "show me this colour" — jumping the
      page to the order table takes the buyer away from the photo they just asked to see, which
      is the opposite of what the click was for. The uf-colour-<id>-<colour> anchors stay on the
      quick order list and the prepack rows so a colour is still directly linkable.
    */
  });
})();
